import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import ChipInput from "material-ui-chip-input";
import FormGroup from '@material-ui/core/FormGroup';
import { currencies } from '../api/countries';
import Tooltip from '@material-ui/core/Tooltip';
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import React from "react";
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { countries, countryToFlag } from '../api/countries';
import { States}  from "../api/states";
import PlacePicker from "../components/PlacePicker";
import config from '../config';
import  formatLocation from "../utils/formatLocation";

import { KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { Grid, Switch, TextField, Typography, OutlinedInput, Box, makeStyles } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

import { useInput } from "../utils/useInputHook";
import { useAlert } from "react-alert";
import { useEffect, useState } from "react";
import { Fragment } from 'react';

const filter = createFilterOptions();
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" htmlColor="#ff3f71" />;

export const getDefaultValueByWidgetType = (widgetType) => {
    switch (widgetType) {
        case 'TextWidget':
        case 'NumberWidget':
        case 'RadioWidget':
        case 'TextAreaWidget':
        case 'SelectWidget':
            return null;
        case 'TextListWidget':
        case 'CheckBoxWidget':
        case 'MultiSelectWidget':
        case 'MultiSelectWidget_OtherText':
        case 'SelectWidget_OtherText':
        case 'TextWidget_Dynamic':
            return [];
        case 'DateRangeWidget':
        case 'TimeRangeWidget':
            return [new Date(), new Date()]
        case 'NumberRangeWidget':
            return [null,null ];
        case 'UnitInputWidget':
            return [null, null];
        case 'CurrencyWidget':
            return ["GBP", null];
        case 'NumberWidget_Unit':
            return [null, null];
        case 'MinMaxUnitWidget':
            return [null, null, null];
        case 'KeyValueWidget':
            return [];
        case 'KeyValueWidgetUnit':
            return [];
        case 'KeyToggleValueWidgetUnit':
            return [];
        case 'AddressWidget':
            return {
                address_line_1:"",
                street: "",
                landmark: "",
                area: "",
                city: "",
                state: "",
                country: "United Kingdom",
                zip_code: "",
                location: {
                    longitude: 0,
                    latitude: 0
                },
                }
        default:
            return null;
    }
}

const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 36,
      height: 18,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(18px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#0097a7',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 16,
      height: 16,
    },
    track: {
      borderRadius: 16 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: "#999999",
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
  });

export const TextWidget = ({ name, questionIndex, question, description, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
                
                <TextField {...inputProps}
                    disabled = {!is_applicable}
                    margin="dense"
                    style={{ maxWidth: 400 }}
                    placeholder={name}
                    value={inputProps.currentValue}
                    onChange={(e) => handleChange(e.target.value)}
                    fullWidth />
            </Grid>
        </Grid >
    )
}

export const NumberWidget = ({ name, questionIndex, question, description, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                        <Grid item xs>
                            <Tooltip title={description} placement="bottom-start">
                                <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                    {`Q${questionIndex} `}
                                    {question}</Typography>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={1}>
                            <FormControlLabel
                                control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                            />
                        </Grid>
                    </Grid>
                
                <TextField {...inputProps}
                    disabled = {!is_applicable}
                    margin="dense"
                    style={{ maxWidth: 400 }}
                    value={inputProps.currentValue}
                    onChange={(e) => handleChange(e.target.value)}
                    type="number" fullWidth 
                    />
            </Grid>
        </Grid >
    )
}

export const RadioWidget = ({ name, questionIndex, question, description, widget_configuration, handleChange, currentValue, defaultValue, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <FormControl component="fieldset" fullWidth >
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <RadioGroup
                disabled = {!is_applicable}
                aria-label="radio" name="radio"
                {...inputProps} value={currentValue || ''}
                defaultValue={defaultValue} onChange={(e) => handleChange(e.target.value)}
            >
                {
                    widget_configuration.options.map((option, i) => (
                        <FormControlLabel value={convertObjectOrStringToValue(option)} key={convertObjectOrStringToValue(option)} control={<Radio />} label={convertObjectOrStringToValue(option)} />
                    ))
                }
            </RadioGroup>
        </FormControl >
    )
}

const convertObjectOrStringToValue = (option) => {
    return (typeof option === 'object' && option !== null) ? Object.keys(option)[0] : option;
}

export const SelectWidget = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        
        <FormControl component="fieldset" fullWidth>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}> 
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <Autocomplete
                disabled = {!is_applicable}
                {...inputProps} value={inputProps.currentValue}
                onChange={(e) => handleChange(e.target.outerText)}
                options={widget_configuration.options.map((option, i) =>(convertObjectOrStringToValue(option))).sort()}
                renderInput={(params) => (
                <TextField {...params} label="" margin="dense" variant="outlined" />
                )}
            />
            {/* <Select margin="dense" style={{ margin: '4px 0' }} displayEmpty
                {...inputProps} value={inputProps.currentValue}
                // onChange={(e) => {console.log(e.target.value,e)}}
                onChange={(e) => handleChange(e.target.value)}
                variant="outlined"
            >
                <MenuItem value="" disabled>
                    {trait_name}
                </MenuItem>
                {
                    widget_configuration.options.map((option, i) => (
                        <MenuItem value={convertObjectOrStringToValue(option)} key={convertObjectOrStringToValue(option)} >
                            {convertObjectOrStringToValue(option)}
                        </MenuItem>
                    ))
                }
            </Select> */}
        </FormControl >
    )
}

export const SelectWidget_OtherText = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        
        <FormControl component="fieldset" fullWidth>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <Autocomplete
                disabled = {!is_applicable}
                {...inputProps} value={inputProps.currentValue}
                onChange={(e) => handleChange(e.target.outerText)}
                freeSolo
                options={widget_configuration.options.map((option, i) =>(convertObjectOrStringToValue(option))).sort()}
                renderInput={(params) => (
                <TextField {...params} label="" margin="dense" variant="outlined" />
                )}
            />
            
        </FormControl >
    )
}

export const ToggleWidget = ({ trait_name, question, questionIndex, description, widget_configuration, currentValue, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <FormControl component="fieldset" fullWidth>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <FormControlLabel
                control={
                    <Switch disabled = {!is_applicable}
                        checked={currentValue || inputProps.defaultvalue || false}
                        name={trait_name} color="primary"
                        onChange={e => handleChange(e.target.checked)} />
                }
                label={currentValue ? 'Yes' : 'No'}
            />
        </FormControl>
    )
}

export const DateWidget = ({ trait_name, questionIndex, question, description, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
                <KeyboardDatePicker
                    disabled = {!is_applicable}
                    inputVariant="outlined"
                    variant="dialog"
                    format="dd/MM/yyyy"
                    style={{ maxWidth: 300 }}
                    margin="dense"
                    value={inputProps.currentValue}
                    fullWidth
                    onChange={(t) => handleChange(t)}
                />
            </Grid>
        </Grid >
    )
}

export const TimeWidget = ({ trait_name, questionIndex, question, description, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
                <KeyboardTimePicker
                    disabled = {!is_applicable}
                    margin="dense"
                    size="small"
                    inputVariant="outlined"
                    style={{ maxWidth: 300 }}
                    value={inputProps.currentValue}
                    fullWidth
                    onChange={(t) => handleChange(t)}
                />
            </Grid>
        </Grid >
    )
}

export const CustomTag = ({ trait_name, description, handleChange, onDelete }) => {
    return (
        <Box style={{ display: 'flex', width: '100%' }}>
            <TextField
                value={trait_name}
                variant="outlined"
                label="Name"
                rows={2}
                multiline
                style={{ flex: '1', marginRight: 8 }}
                margin="dense"
                onChange={(e) => handleChange({ name: e.target.value })}
                fullWidth />
            <TextField value={description}
                margin="dense"
                label="Description"
                style={{ flex: '1' }}
                variant="outlined"
                rows={2}
                multiline
                onChange={(e) => handleChange({ description: e.target.value })}
                fullWidth />
            <IconButton edge="end" aria-label="delete" onClick={onDelete}>
                <DeleteIcon />
            </IconButton>
        </Box >
    )
}

export const MultiSelectWidget = ({ trait_name, questionIndex, question, description, widget_configuration, handleChange, ...inputProps }) => {
    const [current, setCurrent] = useState(inputProps.currentValue);
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    // console.log(inputProps.currentValue)
    return (
        <FormControl component="fieldset" fullWidth>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <Autocomplete
                multiple
                disabled = {!is_applicable}
                {...inputProps} value={current}
                onChange={(e, newValue) => {setCurrent(newValue);handleChange(newValue)}}
                options = {widget_configuration.options.map((option, i) =>(convertObjectOrStringToValue(option))).sort()}
                disableCloseOnSelect
                getOptionLabel={(option) => convertObjectOrStringToValue(option)}
                renderOption={(option, { selected }) => (
                    // console.log(option,selected),
                    <React.Fragment>
                    <Checkbox
                        
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {convertObjectOrStringToValue(option)}
                    </React.Fragment>
                )}
                // style={{ width: 00 }}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    margin="dense"
                    variant="outlined"
                    label=""
                    placeholder=""
                    />
                )}
                />
            {/* <Select margin="dense" style={{ margin: '4px 0' }}
                displayEmpty multiple
                {...inputProps} value={inputProps.currentValue}
                onChange={(e) => handleChange(e.target.value)}
                variant="outlined">
                <MenuItem value="" disabled>
                    {trait_name}
                </MenuItem>
                {
                    widget_configuration.options.map((option, i) => (
                        <MenuItem value={convertObjectOrStringToValue(option)} key={convertObjectOrStringToValue(option)}>{convertObjectOrStringToValue(option)}</MenuItem>
                    ))
                }
            </Select> */}
        </FormControl >
    )
}


export const MultiSelectWidget_OtherText = ({ trait_name, questionIndex, question, description, widget_configuration, handleChange, ...inputProps }) => {
    const [current, setCurrent] = useState(inputProps.currentValue);
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    // console.log(inputProps.currentValue)
    return (
        <FormControl component="fieldset" fullWidth>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}> 
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <Autocomplete
                disabled = {!is_applicable}
                {...inputProps} value={current}
                onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                    setCurrent({
                    newValue,
                    });
                } else {
                    setCurrent(newValue);
                }
                handleChange(newValue)
                }}
                filterOptions={(options, params) => {
                const filtered = filter(options, params);
                // Suggest the creation of a new value
                if (params.inputValue !== '' && !(options.includes(params.inputValue))) {
                    filtered.push(
                    params.inputValue,
                    );
                }
        
                return filtered;
                }}
                multiple
                freeSolo
                options = {widget_configuration.options.map((option, i) =>(convertObjectOrStringToValue(option))).sort()}
                disableCloseOnSelect
                getOptionLabel={(option) => convertObjectOrStringToValue(option)}
                renderOption={(option, { selected }) => (
                    // console.log(option,selected),
                    <React.Fragment>
                    <Checkbox
                        
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {convertObjectOrStringToValue(option)}
                    </React.Fragment>
                )}
                // style={{ width: 00 }}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    margin="dense"
                    variant="outlined"
                    label=""
                    placeholder=""
                    />
                )}
                />
            
        </FormControl >
    )
}


export const CheckBoxWidget = ({ trait_name, questionIndex, question, description, widget_configuration, handleChange, currentValue, ...inputProps }) => {
    const onToggle = (option) => () => {
        if (currentValue.includes(option)) {
            const copy = [...currentValue];
            handleChange(copy.filter(e => e !== option));
            return;
        }
        handleChange([...currentValue, option]);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <FormControl component="fieldset">
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            <FormGroup>
                {
                    widget_configuration.options.map((option, i) => (
                        <FormControlLabel
                            label={convertObjectOrStringToValue(option)}
                            control={
                                <Checkbox disabled = {!is_applicable} checked={currentValue?.includes(convertObjectOrStringToValue(option))}
                                    onChange={onToggle(convertObjectOrStringToValue(option))} value={convertObjectOrStringToValue(option)} key={convertObjectOrStringToValue(option)} />
                            }
                        />
                    ))
                }
            </FormGroup>
        </FormControl>
    );
}

export const DateRangeWidget = ({ trait_name, questionIndex, question, description, handleChange, ...inputProps }) => {
    const onChange = (i) => (val) => {
        const copy = [...inputProps.currentValue];
        copy[i] = val;
        handleChange(copy);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <KeyboardDatePicker
                    disabled = {!is_applicable}
                    inputVariant="outlined"
                    variant="dialog"
                    format="dd/MM/yyyy"
                    label="Start"
                    margin="dense"
                    value={inputProps.currentValue[0]}
                    fullWidth
                    onChange={onChange(0)}
                />
            </Grid>
            <Grid item xs={6}>
                <KeyboardDatePicker
                    disabled = {!is_applicable}
                    inputVariant="outlined"
                    variant="dialog"
                    format="dd/MM/yyyy"
                    label="End"
                    margin="dense"
                    value={inputProps.currentValue[1]}
                    fullWidth
                    onChange={onChange(1)}
                />
            </Grid>
        </Grid >
    )
}

export const TimeRangeWidget = ({ trait_name, questionIndex, question, description, handleChange, ...inputProps }) => {
    const onChange = (i) => (val) => {
        const copy = [...inputProps.currentValue];
        copy[i] = val;
        handleChange(copy);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <KeyboardTimePicker
                    disabled = {!is_applicable}
                    margin="dense"
                    label="Start"
                    size="small"
                    inputVariant="outlined"
                    value={inputProps.currentValue[0]}
                    fullWidth
                    onChange={onChange(0)}
                />
            </Grid>
            <Grid item xs={6}>
                <KeyboardTimePicker
                    disabled = {!is_applicable}
                    margin="dense"
                    label="End"
                    size="small"
                    inputVariant="outlined"
                    value={inputProps.currentValue[1]}
                    fullWidth
                    onChange={onChange(1)}
                />
            </Grid>
        </Grid >
    )
}

const range = function (a, b, step) {
    var A = [];
    A[0] = { value: a, label: a };
    step = step || 1;
    while (a + step <= b) {
        A[A.length] = { value: a += step, label: a += step };
    }

    return A;
}

export const NumberRangeWidget = ({ trait_name, questionIndex, question, description, widget_configuration, handleChange, ...inputProps }) => {
    // console.log(inputProps)
    // const [value, setValue] = useState([widget_configuration.min,widget_configuration.max])
    // const onChange  = (event, newValue) => {
    //     setValue(newValue);
    //     let copy = newValue
    //     handleChange(copy);
    // }
    // const marks = range(widget_configuration.min,widget_configuration.max,10);
    // return (
    //     <Grid container spacing={1} >
    //         <Grid item xs={12}>
    //             <Typography  gutterBottom>
    //                 {`Q${questionIndex} `}
    //                 {question}
    //             </Typography>
    //         </Grid>
    //         <Grid item xs={12}>
    //         <Slider
    //             value={value}
    //             onChange={onChange}
    //             valueLabelDisplay="auto"
    //             aria-labelledby="range-slider"
    //             step = {10}
    //             mark = {marks}
    //         />
    //         </Grid>

    //     </Grid >
    const onChange = (i) => (e) => {
        const copy = [...inputProps.currentValue];
        copy[i] = e.target.value;
        handleChange(copy);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                <TextField {...inputProps}
                    disabled = {!is_applicable}
                    margin="dense"
                    label="Min"
                    variant="outlined"
                    value={inputProps.currentValue[0]}
                    onChange={onChange(0)}
                    type="number" fullWidth />
            </Grid>
            <Grid item xs={6}>
                <TextField {...inputProps}
                    disabled = {!is_applicable}
                    margin="dense"
                    label="Max"
                    variant="outlined"
                    value={inputProps.currentValue[1]}
                    onChange={onChange(1)}
                    type="number" fullWidth />
            </Grid>
        </Grid >
    )
}


export const UnitInputWidget = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    console.log({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps })
    const onChange = (i) => (e) => {
        const copy = [...inputProps.currentValue];
        copy[i] = e.target.value;
        handleChange(copy);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={8}>
                <TextField label="Value" variant="outlined" 
                    disabled = {!is_applicable}
                    value={inputProps.currentValue[0]}
                    onChange={onChange(0)}
                    fullWidth margin="dense" />
            </Grid>
            <Grid item xs={4} style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                <FormControl variant="outlined" fullWidth>
                    {/* <InputLabel id={trait_name} margin="dense">Unit</InputLabel> */}
                    <Autocomplete
                        disabled = {!is_applicable}
                        value={inputProps.currentValue[1]}
                        onChange={(e) => {const copy = [...inputProps.currentValue];
                            copy[1] = e.target.outerText;
                            handleChange(copy);}}
                        options={widget_configuration.units}
                        renderInput={(params) => (
                        <TextField {...params} label="Unit" margin="dense" variant="outlined" />
                        )}
                    />
                    {/* <Select
                        labelId={trait_name}
                        value={inputProps.currentValue[1]}
                        onChange={onChange(1)}
                        input={<OutlinedInput margin='dense' label="Unit" />}
                        inputProps={{ margin: "dense" }}
                    >
                        {
                            widget_configuration?.units?.map((option, i) => (
                                <MenuItem value={option} key={i}>{option}</MenuItem>
                            ))
                        }
                    </Select> */}
                </FormControl>
            </Grid>
        </Grid>
    );
}

export const MinMaxUnitWidget = ({ trait_name, questionIndex, question, description, widget_configuration, handleChange, ...inputProps }) => {
    
    const onChange = (i) => (e) => {
        const copy = [...inputProps.currentValue];
        copy[i] = e.target.value;
        handleChange(copy);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ alignItems: 'center'}}>
                <Grid item xs={3}>
                    <TextField {...inputProps}
                        disabled = {!is_applicable}
                        margin="dense"
                        label="Min"
                        variant="outlined"
                        value={inputProps.currentValue[0]}
                        onChange={onChange(0)}
                        type="number" fullWidth />
                </Grid>
                {/* <Grid item xs>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel id={trait_name} margin="dense">Unit</InputLabel>
                        <Autocomplete
                            value={inputProps.currentValue[1]}
                            onChange={(e) => {onChange(1)}}
                            options={widget_configuration.units}
                            renderInput={(params) => (
                            <TextField {...params} margin="normal" variant="outlined" />
                            )}
                        />
                    </FormControl>
                </Grid> */}
                <Grid item>
                    <Typography>-</Typography>
                </Grid>
                <Grid item xs ={3}>
                    <TextField {...inputProps}
                        disabled = {!is_applicable}
                        margin="dense"
                        label="Max"
                        variant="outlined"
                        value={inputProps.currentValue[1]}
                        onChange={onChange(1)}
                        type="number" fullWidth />
                </Grid>
                <Grid item xs style={{marginLeft:30}}>
                    <FormControl variant="outlined" fullWidth>
                        <Autocomplete
                            disabled = {!is_applicable}
                            value={inputProps.currentValue[2]}
                            onChange={(e) => {const copy = [...inputProps.currentValue];
                                copy[2] = e.target.outerText;
                                handleChange(copy);}}
                            options={widget_configuration.units}
                            renderInput={(params) => (
                            <TextField {...params} label="Unit" margin="dense" variant="outlined" />
                            )}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </Grid >
    )
}


export const ChipListWidget = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0} >
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
                <ChipInput style={{ margin: '8px 0' }} disabled = {!is_applicable} dataSource={widget_configuration.options}
                    variant="outlined" placeholder="Enter values" fullWidth
                    defaultValue={inputProps.currentValue} onChange={(chips) => handleChange(chips)} />
            </Grid>
        </Grid >
    )
}

export const TextAreaWidget = ({ trait_name, question, questionIndex, description, handleChange, ...inputProps }) => {
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
                <TextField {...inputProps}
                    disabled = {!is_applicable}
                    margin="dense"
                    variant="outlined"
                    rows={4}
                    placeholder={trait_name}
                    value={inputProps.currentValue}
                    onChange={(e) => handleChange(e.target.value)}
                    fullWidth />
            </Grid>
        </Grid >
    )
}

export const CurrencyWidget = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {

    const onChange = (i) => (e,val) => {
        const copy = [...inputProps.currentValue];
        if ( i == 0) {
            copy[i] = val;
        } else {
            copy[i] = e.target.value;
        }
        console.log(copy)
        handleChange(copy);
    }
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    return (
        <Grid container spacing={0} >
            <Grid item xs={12}>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Tooltip title={description} placement="bottom-start">
                        <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                            {`Q${questionIndex} `}
                            {question}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <FormControlLabel
                        control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                    />
                </Grid>
            </Grid>
            </Grid>
            <Autocomplete
                disabled = {!is_applicable}
                options={currencies.sort()}
                autoHighlight
                disableClearable
                value={inputProps.currentValue[0]}
                onChange={onChange(0)}
                style={{ width: 140, marginRight: 8 }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Currency"
                        margin="dense"
                        variant="outlined"
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                    />
                )}
            />
            <TextField
                disabled = {!is_applicable}
                label="Cost" variant="outlined"
                margin="dense"
                value={inputProps.currentValue[1]}
                onChange={onChange(1)}
                type="number" style={{ flex: '1' }} 
                InputProps={{ inputProps: {min: "0"}}}
                error={inputProps.currentValue[1]>=0?false:true}
                helperText={inputProps.currentValue[1]>=0?"":"Cannot be less than 0"}/>
        </Grid>
        
    );
}

export const TextListWidget = ({ trait_name, question, questionIndex, description, handleChange, ...inputProps }) => {
    const [value, setValue] = useState('');
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    const onAdd = () => {
        if (value && value !== '') {
            handleChange([...inputProps.currentValue, value]);
            setValue('');
        }
    }
    const onRemove = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        handleChange(copy.filter(v => v !== selectedVal));
    }
    const onEdit = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        setValue(selectedVal)
        handleChange(copy.filter(v => v !== selectedVal));
    }
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <List dense>
                    {
                        inputProps.currentValue?.map(item => (
                            <ListItem divider>
                                <Grid container spacing={1} style={{ alignItems: 'center'}}>
                                    <Grid item xs >
                                        <Typography>{item}</Typography>
                                    </Grid>
                                    <Grid item>
                                            <IconButton aria-label="edit" onClick={onEdit(item)}>
                                                <EditIcon />
                                            </IconButton>
                                    </Grid>
                                    <Grid item>
                                            <IconButton edge="end" aria-label="delete" onClick={onRemove(item)}>
                                                <DeleteIcon />
                                            </IconButton>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))
                    }
                </List>
            </Grid>
            <Grid item xs={12} style={{ display: 'flex' }}>
                <TextField {...inputProps}
                    disabled = {!is_applicable}
                    value={value} onChange={e => setValue(e.target.value)}
                    margin="dense" variant="outlined" rows={4}
                    placeholder="Enter value"
                    fullWidth />
                <IconButton aria-label="add" disabled = {!is_applicable} onClick={onAdd}>
                    <AddIcon />
                </IconButton>
            </Grid>
        </Grid >
    )
}

export const KeyValueWidget = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    const [key, setKey] = useState('');
    const [value, setValue] = useState('');
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    const onAdd = () => {
        if (key !== '' && value !== '') {
            handleChange([...inputProps.currentValue, [key,value]]);
            setKey('');
            setValue('');
        }
    }
    const onRemove = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        handleChange(copy.filter(v => v !== selectedVal));
    }
    const onEdit = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        setKey(selectedVal[0])
        setValue(selectedVal[1])
        handleChange(copy.filter(v => v !== selectedVal));
    }
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex}  `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <List dense>
                    {
                        inputProps.currentValue?.map(item => (
                            <ListItem divider>
                                <Grid container spacing={1} style={{ alignItems: 'center'}}>
                                    <Grid item xs >
                                        <Typography>{item[0]}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography>{item[1]}</Typography>
                                    </Grid>
                                    <Grid item>
                                            <IconButton aria-label="edit" onClick={onEdit(item)}>
                                                <EditIcon />
                                            </IconButton>
                                    </Grid>
                                    <Grid item>
                                            <IconButton edge="end" aria-label="delete" onClick={onRemove(item)}>
                                                <DeleteIcon />
                                            </IconButton>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))
                    }
                </List>
            </Grid>
            <Grid container spacing={1} style={{ alignItems: 'center'}}>
                <Grid item xs >
                    <FormControl variant="outlined" fullWidth>
                        <Autocomplete
                            freeSolo
                            disabled = {!is_applicable}
                            value={key}
                            onChange={(e) => {setKey(e.target.outerText)}}
                            options={widget_configuration.options.map((option, i) =>(convertObjectOrStringToValue(option))).sort()}
                            renderInput={(params) => (
                            <TextField {...params} label="" margin="dense" variant="outlined" />
                            )}
                        />
                    </FormControl>
                    {/* <TextField {...inputProps} 
                        disabled = {!is_applicable}
                        value={key} onChange={e => setKey(e.target.value)}
                        margin="dense" variant="outlined" rows={4}
                        placeholder="Item"
                        fullWidth /> */}
                </Grid>
                <Grid item>
                    <Typography> - </Typography>
                </Grid>
                <Grid item xs>
                    <TextField {...inputProps}
                        disabled = {!is_applicable}
                        value={value} onChange={e => setValue(e.target.value)}
                        margin="dense" variant="outlined" rows={4}
                        placeholder="Value"
                        fullWidth />
                </Grid>
                <Grid item>
                    <IconButton aria-label="add" onClick={onAdd}>
                        <AddIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid >
    )
}

export const KeyValueWidgetUnit = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    const [key, setKey] = useState('');
    const [value, setValue] = useState('');
    const [unit, setUnit] = useState(widget_configuration?.default||'');
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    const onAdd = () => {
        if ((key && key !== '') || (value && value !== '') || (unit && unit !== '')) {
            console.log(key,value,unit,inputProps.currentValue)
            handleChange([...inputProps?.currentValue, [key,value,unit]]);
            setKey('');
            setValue('');
            setUnit('');
        }
    }
    const onRemove = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        handleChange(copy.filter(v => v !== selectedVal));
    }
    const onEdit = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        setKey(selectedVal[0])
        setValue(selectedVal[1])
        setUnit(selectedVal[2])
        handleChange(copy.filter(v => v !== selectedVal));
    }
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <List dense>
                    {
                        inputProps.currentValue?.map(item => (
                            <ListItem divider>
                                <Grid container spacing={1} style={{ alignItems: 'center'}}>
                                    <Grid item xs={6} >
                                        <Typography>{item[0]}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item >
                                        <Typography>{item[1]}</Typography>
                                    </Grid>
                                    <Grid item xs style={{marginLeft:30}}>
                                        <Typography>{item[2]}</Typography>
                                    </Grid>
                                    <Grid item xs ={1}>
                                            <IconButton disabled = {!is_applicable} aria-label="edit" onClick={onEdit(item)}>
                                                <EditIcon />
                                            </IconButton>
                                    </Grid>
                                    <Grid item xs ={1}>
                                            <IconButton disabled = {!is_applicable} edge="end" aria-label="delete" onClick={onRemove(item)}>
                                                <DeleteIcon />
                                            </IconButton>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))
                    }
                </List>
            </Grid>
            <Grid container spacing={1} style={{ alignItems: 'center'}}>
                <Grid item xs ={6}>
                    <FormControl variant="outlined" fullWidth>
                        <Autocomplete
                            disabled = {!is_applicable}
                            freeSolo
                            autoSelect
                            value={key}
                            onChange={(e,newValue) => {
                                // console.log(e,newValue)
                                if (typeof newValue === 'string') {
                                    setKey(newValue);
                                }  else if (newValue && newValue.inputValue) {
                                    setKey(newValue.inputValue)
                                } else {
                                    setKey(newValue);
                                }
                            }}
                            options={widget_configuration?.options.map((option, i) =>(convertObjectOrStringToValue(option)))}
                            renderInput={(params) => (
                            <TextField {...params} label="Item" margin="dense" variant="outlined" />
                            )}
                            />
                    </FormControl>
                    {/* <TextField {...inputProps}
                        disabled = {!is_applicable}
                        value={key} onChange={e => setKey(e.target.value)}
                        margin="dense" variant="outlined" rows={4}
                        placeholder="Item"
                        fullWidth /> */}
                </Grid>
                <Grid item>
                    <Typography>-</Typography>
                </Grid>
                <Grid item xs ={2}>
                    <TextField {...inputProps}
                        disabled = {!is_applicable}
                        value={value} onChange={e => setValue(e.target.value)}
                        margin="dense" variant="outlined" rows={4}
                        placeholder="Value" type="number"
                        fullWidth />
                </Grid>
                <Grid item xs={2} style={{marginLeft:30}}>
                    <FormControl variant="outlined" fullWidth>
                        <Autocomplete
                            disabled = {!is_applicable}
                            value={unit}
                            onChange={e => setUnit(e.target.outerText)}
                            options={widget_configuration.units}
                            renderInput={(params) => (
                            <TextField {...params} label="Unit" margin="dense" variant="outlined" />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <IconButton disabled = {!is_applicable} aria-label="add" onClick={onAdd}>
                        <AddIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid >
    )
}

export const KeyToggleValueWidgetUnit = ({ trait_name, question, questionIndex, description, widget_configuration, handleChange, ...inputProps }) => {
    const [key, setKey] = useState('');
    const [toggle, setToggle] = useState(false);
    const [value, setValue] = useState('');
    const [unit, setUnit] = useState('');
    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    const onAdd = () => {
        if ((key && key !== '') || (value && value !== '') || (unit && unit !== '')) {
            handleChange([...inputProps.currentValue, [key,toggle,value,unit]]);
            setKey('');
            setToggle(false)
            setValue('');
            setUnit('');
        }
    }
    const onRemove = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        handleChange(copy.filter(v => v !== selectedVal));
    }
    const onEdit = (selectedVal) => () => {
        const copy = [...inputProps.currentValue];
        setKey(selectedVal[0])
        setToggle(selectedVal[1])
        setValue(selectedVal[2])
        setUnit(selectedVal[3])
        handleChange(copy.filter(v => v !== selectedVal));
    }
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <List dense>
                    {
                        inputProps.currentValue?.map(item => (
                            <ListItem divider>
                                <Grid container spacing={1} style={{ alignItems: 'center'}}>
                                    <Grid item xs={6} >
                                        <Typography>{item[0]}</Typography>
                                    </Grid>
                                    <Grid item xs = {2}>
                                        <Typography>{item[1]?"Provided":"Not provided"}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography>-</Typography>
                                    </Grid>
                                    <Grid item >
                                        <Typography>{item[2]}</Typography>
                                    </Grid>
                                    <Grid item xs style={{marginLeft:30}}>
                                        <Typography>{item[3]}</Typography>
                                    </Grid>
                                    <Grid item xs ={1}>
                                            <IconButton disabled = {!is_applicable} aria-label="edit" onClick={onEdit(item)}>
                                                <EditIcon />
                                            </IconButton>
                                    </Grid>
                                    <Grid item xs ={1}>
                                            <IconButton disabled = {!is_applicable} edge="end" aria-label="delete" onClick={onRemove(item)}>
                                                <DeleteIcon />
                                            </IconButton>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))
                    }
                </List>
            </Grid>
            <Grid container spacing={1} style={{ alignItems: 'center'}}>
                <Grid item xs ={6}>
                    <TextField {...inputProps}
                        disabled = {!is_applicable}
                        value={key} onChange={e => setKey(e.target.value)}
                        margin="dense" variant="outlined" rows={4}
                        placeholder="Item"
                        fullWidth />
                </Grid>
                <Grid item xs> 
                    <Tooltip title="Select yes if the equipment is available for rental from the provider" placement="bottom-start">
                    <FormControlLabel
                        control={
                            <Switch disabled = {!is_applicable}
                                checked={toggle}
                                name={trait_name} color="primary"
                                onChange={e => setToggle(e.target.checked)} />
                        }
                        label={toggle ? 'Provided' : 'Not provided'}
                    />
                    </Tooltip>
                </Grid>
                <Grid item xs>
                    <TextField {...inputProps}
                        disabled = {!is_applicable}
                        value={value} onChange={e => setValue(e.target.value)}
                        margin="dense" variant="outlined" rows={4}
                        placeholder="Value" type="number"
                        fullWidth />
                </Grid>
                <Grid item xs style={{marginLeft:30}}>
                    <FormControl variant="outlined" fullWidth>
                        <Autocomplete
                            disabled = {!is_applicable}
                            value={unit}
                            onChange={e => setUnit(e.target.outerText)}
                            options={widget_configuration.units}
                            renderInput={(params) => (
                            <TextField {...params} label="Unit" margin="dense" variant="outlined" />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <IconButton disabled = {!is_applicable} aria-label="add" onClick={onAdd}>
                        <AddIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid >
    )
}


export const OldAddressWidget = ({ trait_name, question, questionIndex, description,  handleChange, ...inputProps }) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            '& .MuiTextField-root': {
                margin: theme.spacing(1, 0),
                width: '100%',
            },
        },
        heading: {
            margin: theme.spacing(1, 0, 2, 0)
        },
        phoneInput: {
            width: '100% !important',
            '&:focus': {
                borderColor: `${theme.palette.primary.main} !important`,
                boxShadow: `0 0 0 1px ${theme.palette.primary.main} !important`
            }
        },
        option: {
            fontSize: 15,
            '& > span': {
                marginRight: 10,
                fontSize: 18,
            },
        },
    }));

    

    const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
    const classes = useStyles();
    const [address_line_1, setAddressLine1] = useState(inputProps?.currentValue?.address_line_1||'');
    const [street, setStreet] = useState(inputProps?.currentValue?.street||'');
    const [landmark, setLandmark] = useState(inputProps?.currentValue?.landmark||'');
    const [area, setArea] = useState(inputProps?.currentValue?.area||'');
    const [city, setCity] = useState(inputProps?.currentValue?.city||'');
    const [state, setStateValue] = useState(inputProps?.currentValue?.state|| {name:"City of London"});
    const [country, setCountry] = useState({label:inputProps?.currentValue?.country}||{label:"United Kingdom"})
    const [location, setLocation] = useState(inputProps?.currentValue?.location||{ lat: 0, lng: 0 });
    const { value: zip_code, bind: bindZipCode } = useInput(inputProps?.currentValue?.zip_code || '');
    const [mapLoading, setMapLoading] = useState(false);

    const setFilterStates = (label) => {
        const country =  countries.filter((d) => d.label == label);
        const filterStateData = States.filter((d) => (d.country_code === country[0].code));
        return filterStateData;
     };
    const [filterState, setFilterState] = useState(setFilterStates("United Kingdom"));

    const onCountryChange = (value) => {
        setCountry(value);
        filterStateFun(value.code);
        setStateValue({name:''});
      };

    const filterStateFun = (countryCode) => {
        const filterStateData = States.filter((d) => 
        (d.country_code === countryCode));
        setFilterState(filterStateData);
      };

    useEffect(() => {
        setMapLoading(true);
        const delayed = setTimeout(async () => {
            console.log('stopped typing, checking location');
            try {
                const combined = [address_line_1, street, area, city, state?.name, country?.label || '',zip_code].join(',');
                const current_address = [
                    inputProps?.currentValue?.address_line_1,
                    inputProps?.currentValue?.street,
                    inputProps?.currentValue?.area,
                    inputProps?.currentValue?.city,
                    inputProps?.currentValue?.state,
                    inputProps?.currentValue?.country,
                    inputProps?.currentValue?.zip_code
                ].join(',');

                if (combined === current_address) {
                    console.log('address same => setting to saved location',current_address,combined)
                    setLocation(formatLocation(inputProps?.currentValue?.location))
                    return;
                }
                if (combined.length < 5)
                    return;
                console.log(`Fetching new location`)
                const url = (`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(combined)}&key=${config.GOOGLE_MAPS_API_KEY}`);
                const req = await fetch(url);
                const data = await req.json();
                if (data.status === 'OK') {
                    const location = data.results[0].geometry.location;
                    console.log(`Locationfound`, location);
                    setLocation(location)
                } else {
                    console.log('no data?', data);
                    alert.show("Could not find location");
                }
            } catch (e) {
                console.log(e)
            } finally {
                setMapLoading(false);
            }
        }, 1000);
        return () => clearTimeout(delayed)

    }, [address_line_1, street, area, city, state, country, zip_code, inputProps?.currentValue])

    const onAddressLine = (e) => {
        setAddressLine1(e.target.value);
        const copy = inputProps.currentValue;
        copy.address_line_1=e.target.value;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onStreet = (e) => {
        setStreet(e.target.value);
        const copy = inputProps.currentValue;
        copy.street=e.target.value;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onLandmark = (e) => {
        setLandmark(e.target.value);
        const copy = inputProps.currentValue;
        copy.landmark=e.target.value;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onArea = (e) => {
        setArea(e.target.value);
        const copy = inputProps.currentValue;
        copy.area=e.target.value;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onCity = (e) => {
        setCity(e.target.value);
        const copy = inputProps.currentValue;
        copy.city=e.target.value;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onState = (e,val) => {
        setStateValue(val);
        const copy = inputProps.currentValue;
        copy.state=val;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onCountry = (e,option) => {
        console.log(e,option)
        setCountry(option);
        const copy = inputProps.currentValue;
        copy.country=option.label;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    const onLocation = () => {
        // setLocation;
        const copy = inputProps.currentValue;
        copy.location.longitude=location.lng;
        copy.location.latitude=location.lat;
        handleChange(copy);
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Tooltip title={description} placement="bottom-start">
                            <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                {`Q${questionIndex} `}
                                {question}</Typography>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                        <FormControlLabel
                            control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField disabled = {!is_applicable} fullWidth label="Office No - Floor - Building Name/ Location point" variant="outlined" value={address_line_1} onChange={e => onAddressLine(e)} />
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField disabled = {!is_applicable} fullWidth label="Street" variant="outlined" value={street} onChange={e => onStreet(e)} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField disabled = {!is_applicable} fullWidth label="Landmark" variant="outlined" value={landmark} onChange={e => onLandmark(e)} />
                    </Grid>
                    
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField disabled = {!is_applicable} fullWidth label="Area" variant="outlined" value={area} onChange={e => onArea(e)} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField disabled = {!is_applicable} fullWidth label="City" variant="outlined" value={city} onChange={e => onCity(e)} />
                    </Grid>
                    
                </Grid>
                <Grid container spacing={1}>
                <Grid item xs={6}>
                        {/* <TextField fullWidth label="State *" variant="outlined" {...bindState} /> */}
                        <Autocomplete disabled = {!is_applicable} 
                            id="State"
                            fullWidth
                            options={filterState}
                            autoHighlight
                            classes={{
                                option: classes.option,
                            }}
                            getOptionLabel={(option) => option.name}
                            disableClearable
                            value={state}
                            onChange={(e, val) => onState(e,val)}
                            renderOption={(option) => (
                                <Fragment>
                                    {option.name}
                                </Fragment>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="State"
                                    variant="outlined"
                                    
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            disabled = {!is_applicable}
                            id="country-select"
                            options={countries}
                            classes={{
                                option: classes.option,
                            }}
                            autoHighlight
                            disableClearable
                            getOptionLabel={(option) => option.label}
                            value={country}
                            onChange={(e, option) => onCountry(e,option)}
                            renderOption={(option) => (
                                <Fragment>
                                    <span>{countryToFlag(option.code)}</span>
                                    {option.label} ({option.code})
                                </Fragment>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    label="Country"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Postcode" variant="outlined" {...bindZipCode} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center', justify: 'center' }}>
                <PlacePicker 
                    disabled = {is_applicable}
                    location={location}
                    loading={mapLoading}
                    onChange={onLocation} />
            </Grid>
        </Grid>
    )}


    const formatLocationDict = (location) => {
        if (!location) {
            return null;
        }
        return {
            lat: location.latitude,
            lng: location.longitude,
        }
    }

    export const AddressWidget = ({ trait_name, question, questionIndex, description,  handleChange, ...inputProps }) => {
        const useStyles = makeStyles((theme) => ({
            option: {
                fontSize: 15,
                '& > span': {
                    marginRight: 10,
                    fontSize: 18,
                },
            },
        }));
        
    
        const [is_applicable,setApplicable] = useState(inputProps.is_applicable);
        const classes = useStyles();
        const {value: address_line_1, bind: bindAddressLine1} = useInput(inputProps?.currentValue?.address_line_1||'');
        const {street, bind: bindStreet} = useInput(inputProps?.currentValue?.street||'');
        const {landmark, bind: bindLandmark} = useInput(inputProps?.currentValue?.landmark||'');
        const {area, bind: bindArea} = useInput(inputProps?.currentValue?.area||'');
        const {city, bind: bindCity} = useInput(inputProps?.currentValue?.city||'');
        const [state, setStateValue] = useState(!!inputProps?.currentValue?.state ? {label:inputProps?.currentValue?.state} : {name:"City of London"});
        const [country, setCountry] = useState(!!inputProps?.currentValue?.country ? {label:inputProps?.currentValue?.country} : {label:"United Kingdom"})
        const [location, setLocation] = useState(formatLocationDict(inputProps?.currentValue?.location));
        const { value: zip_code, bind: bindZipCode } = useInput(inputProps?.currentValue?.zip_code || '');
        const [mapLoading, setMapLoading] = useState(false);
    
        useEffect(() => {
            const delayed = setTimeout(async () => {
                setMapLoading(true);
                console.log('stopped typing, checking location');
                try {
                    const combined = [address_line_1, street, area, city, state?.name, country?.label || '',zip_code].join(',');
                    const address = [
                        inputProps?.currentValue?.address_line_1,
                        inputProps?.currentValue?.street,
                        inputProps?.currentValue?.area,
                        inputProps?.currentValue?.city,
                        inputProps?.currentValue?.state,
                        inputProps?.currentValue?.country,
                        inputProps?.currentValue?.zip_code
                    ].join(',');
                    
                    if (combined === address) {
                        console.log('address same => setting to saved location',address,combined)
                        setLocation(formatLocationDict(inputProps?.currentValue?.location))
                        return;
                    }
                    if (combined.length < 5)
                        return;
                    console.log(address,combined)
                    console.log(`Fetching new location`)
                    const url = (`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(combined)}&key=${config.GOOGLE_MAPS_API_KEY}`);
                    const req = await fetch(url);
                    const data = await req.json();
                    if (data.status === 'OK') {
                        const current_location = data.results[0].geometry.location;
                        console.log(`Locationfound`, current_location);
                        setLocation(current_location)
                        // const copy = inputProps.currentValue;
                        // copy.address_line_1=address_line_1;      
                        // copy.street=street;
                        // copy.landmark=landmark;
                        // copy.area=area;
                        // copy.city=city;
                        // copy.state=state;
                        // copy.country=country?.label;
                        // copy.location.longitude=current_location?.lng;
                        // copy.location.latitude=current_location?.lat;
                        // handleChange(copy);
                        
                    } else {
                        console.log('no data?', data);
                        alert.show("Could not find location");
                    }
                } catch (e) {
                    console.log(e)
                } finally {
                    setMapLoading(false);
                }
            }, 1000);
            return () => clearTimeout(delayed)
    
        }, [address_line_1, street, landmark ,area, city, state, country, zip_code, inputProps])
    
        const onUpdate = () => {
            const copy = inputProps.currentValue;
            copy.address_line_1=address_line_1;      
            copy.street=street;
            copy.landmark=landmark;
            copy.area=area;
            copy.city=city;
            copy.state=state;
            copy.country=country;
            copy.location.longitude=location.lng;
            copy.location.latitude=location.lat;
            handleChange(copy);
        }
    
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs>
                            <Tooltip title={description} placement="bottom-start">
                                <Typography gutterBottom style={{color:is_applicable?"#000000":"#b8b8b8"}}>
                                    {`Q${questionIndex} `}
                                    {question}</Typography>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={1}>
                            <FormControlLabel
                                control={<IOSSwitch checked={is_applicable} onChange={e=>{setApplicable(e.target.checked);handleChange(["is_applicable_flag",e.target.checked])}} />}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField disabled = {!is_applicable} fullWidth label="Office No - Floor - Building Name/ Location point" variant="outlined" {...bindAddressLine1} />
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TextField disabled = {!is_applicable} fullWidth label="Street" variant="outlined" {...bindStreet} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField disabled = {!is_applicable} fullWidth label="Landmark" variant="outlined" {...bindLandmark} />
                        </Grid>
                        
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TextField disabled = {!is_applicable} fullWidth label="Area" variant="outlined" {...bindArea} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField disabled = {!is_applicable} fullWidth label="City" variant="outlined" {...bindCity} />
                        </Grid>
                        
                    </Grid>
                    <Grid container spacing={1}>
                    <Grid item xs={6}>
                            {/* <TextField fullWidth label="State *" variant="outlined" {...bindState} /> */}
                            <Autocomplete disabled = {!is_applicable} 
                                fullWidth
                                options= {['Abu Dhabi', 'Dubai', 'Sharjah', 'Umm al-Qaiwain', 'Fujairah', 'Ajman' , 'Ra\'s al-Khaimah']}
                                autoHighlight
                                disableClearable
                                value={state}
                                onChange={(e, val) => setStateValue(val)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="State"
                                        variant="outlined"
                                        
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                disabled = {!is_applicable}
                                id="country-select"
                                options={countries}
                                classes={{
                                    option: classes.option,
                                }}
                                autoHighlight
                                getOptionLabel={(option) => option.label}
                                value={country}
                                onChange={(e, option) => setCountry(option)}
                                renderOption={(option) => (
                                    <Fragment>
                                        <span>{countryToFlag(option.code)}</span>
                                        {option.label} ({option.code})
                                    </Fragment>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label="Country"
                                        variant="outlined"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth label="Postcode" variant="outlined" {...bindZipCode} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center', justify: 'center' }}>
                    <PlacePicker 
                        disabled = {!is_applicable}
                        location={location}
                        loading={mapLoading}
                        onChange={setLocation} />
                </Grid>
            </Grid>
        )}